import { useContext } from "react";

import IdentifiedUserContext from "../contexts/IdentifiedUserContext";
import { IdentifiedUserContextType } from "../types/IdentifiedUserContext";

export default function useIdentifiedUser() {
  return useContext<IdentifiedUserContextType>(IdentifiedUserContext);
}
